<button
  aria-label="request lifestyle manager"
  mat-mini-fab
  [color]="'primary'"
  class="button-request mat-elevation-z0"
  (click)="openDialog()"
  tourAnchor="manager-special-request.bell"
  id="manager-special-request.bell"
  tabindex="0"
>
  <mat-icon class="bell-icon">notifications_active</mat-icon>
</button>
